<adapt-dashboard-element name="Systems">
    <ng-container *adaptLoading="!systems">
        @if (systems && systems.size > 0) {
            @for (systemId of systems; track systemId) {
                <adapt-link-system [systemEntityId]="systemId"
                                   [accessoryText]="accessoryText(systemId)"
                                   [showIcon]="false"> </adapt-link-system>
            }
        } @else {
            No assigned Systems to display
        }
    </ng-container>
</adapt-dashboard-element>
